import { FORM_TYPE_CREATE_LLM_FLOW } from 'js/constants/formTypes';
import { useCallback } from 'react';
import usePaging from 'new/state/paging/repository/usePaging';
import useFormsAdapter from 'new/state/forms/adapter/useFormsAdapter';
import useFlowsSetup from 'new/components/flows/controller/useFlowsSetup';

export default function useLLMProcessor() {
  const { createSink: createSinkFromForm, updateSink: updateSinkFromForm } =
    useFormsAdapter(FORM_TYPE_CREATE_LLM_FLOW);
  const { getSourceConfigFields, getMetaInfoById, getAuthFields } = usePaging();

  const {
    onSelectConnection,
    data,
    effectiveConnectionType,
    updateFormData,
    resetFormData,
    end,
    start,
  } = useFlowsSetup(FORM_TYPE_CREATE_LLM_FLOW, 'streaming');

  const { selectedConnection, credentialId, connectionType } = data;

  const { connectionCategory } = getMetaInfoById(selectedConnection) || {};

  const createSink = useCallback(
    async (sinkInfo) => {
      const response: any = await createSinkFromForm({
        formType: FORM_TYPE_CREATE_LLM_FLOW,
        credentialId,
        sinkType: 'rest',
        sinkInfo,
      });
      return response?.payload?.formData?.sink;
    },
    [createSinkFromForm, credentialId, selectedConnection, connectionCategory],
  );

  const updateSink = useCallback(
    async (sinkInfo) => {
      const response: any = await updateSinkFromForm({
        sinkInfo,
      });
      return response?.payload?.formData?.sink;
    },
    [updateSinkFromForm, credentialId, selectedConnection, connectionCategory],
  );

  return {
    ...data,
    isEditMode: !!(connectionType === 'SINK' && data.sink?.id),
    startForm: start,
    endForm: end,
    getMetaInfoById,
    getSourceConfigFields,
    connectionCategory,
    getAuthFields,
    createSink,
    updateSink,
    onSelectConnection: onSelectConnection('streaming'),
    effectiveConnectionType,
    updateFormData,
    resetFormData,
  };
}
